import { rem } from 'polished';
import React from 'react';
import styled, { css } from 'styled-components';
const Wrapper = styled.div `
  display: flex;
  ${({ $wrap }) => $wrap &&
    css `
      flex-wrap: wrap;
    `}
  margin: ${({ theme }) => rem(-theme.grid.gutterWidth / 2)};
  & > * {
    margin: ${({ theme }) => rem(theme.grid.gutterWidth / 2)};
  }
`;
const HorizontalLayout = ({ className, children, wrap }) => (React.createElement(Wrapper, { className: className, "$wrap": wrap }, children));
export default HorizontalLayout;
